const FIELDSET_VARIANTS = {
  DEFAULT: 'default',
  INDENTED: 'indented'
};

export { FIELDSET_VARIANTS };
